<template>
    <div>
        <!-- Main Edit Modal -->
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('closeModal')">
                    <div class="modal-container" @click.stop>
                        <!-- Header -->
                        <div class="modal-header-custom d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <button
                                    type="button"
                                    class="back-btn mr-2"
                                    @click="$emit('closeModal')"
                                    aria-label="Kembali"
                                >
                                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.44256 7.93462C6.61274 7.84281 6.71884 7.66823 6.71884 7.47835V4.52166H12.5569C12.8517 4.52166 13.0909 4.28797 13.0909 4.00002C13.0909 3.71207 12.8517 3.47837 12.5569 3.47837H6.71884V0.521683C6.71884 0.331108 6.61274 0.156531 6.44256 0.0654168C6.27239 -0.0270885 6.06447 -0.0208287 5.89999 0.0800228L0.249215 3.55836C0.0939897 3.65434 0 3.82057 0 4.00002C0 4.17947 0.0939897 4.3457 0.249215 4.44168L5.89999 7.92001C5.98686 7.97287 6.08583 8 6.1848 8C6.2731 8 6.3621 7.97774 6.44256 7.93462Z" fill="#111827"/>
                                    </svg>
                                </button>
                                <h5 class="modal-title-custom mb-0">Edit Pengiriman Satuan</h5>
                            </div>
                            <button class="btn btn-close-custom" @click="$emit('closeModal')">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <!-- Body -->
                        <div class="modal-body-custom">
                            <!-- Pos Tujuan -->
                            <div class="modal-form-row">
                                <label class="modal-form-label mb-0">Pos Tujuan</label>
                                <div class="modal-form-input">
                                    <Multiselect
                                        v-model="kode_dealer"
                                        :options="posCodeOptions"
                                        :custom-label="getPosLabel"
                                        placeholder="Pilih Pos Tujuan"
                                        :show-labels="false"
                                        :searchable="true"
                                        :allow-empty="false"
                                        class="custom-modal-select qtrust-select"
                                    />
                                </div>
                            </div>

                            <!-- Jumlah QR -->
                            <div class="modal-form-row">
                                <label class="modal-form-label mb-0">Jumlah QR</label>
                                <div class="modal-form-input">
                                    <Multiselect
                                        v-model="qty"
                                        :options="qtyOptions"
                                        :custom-label="getQtyLabel"
                                        placeholder="Pilih Jumlah QR"
                                        :show-labels="false"
                                        :searchable="true"
                                        :taggable="true"
                                        @tag="addQtyTag"
                                        :allow-empty="false"
                                        class="custom-modal-select qtrust-select"
                                    />
                                </div>
                            </div>

                            <!-- Tanda Tangan -->
                            <div class="modal-form-row align-top">
                                <label class="modal-form-label mb-0 pt-1">Tanda Tangan</label>
                                <div class="modal-form-input">
                                    <div class="signature-box">
                                        <vue-signature-pad width="100%" height="116px" ref="signaturePad" />
                                        <button
                                            type="button"
                                            class="btn-clear-signature"
                                            @click="$refs.signaturePad.clearSignature()"
                                        >
                                            Hapus
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Actions -->
                            <div class="modal-actions-row d-flex justify-content-end align-items-center">
                                <button 
                                    type="button" 
                                    class="btn btn-batal" 
                                    @click="$emit('closeModal')"
                                >
                                    Batal
                                </button>
                                <button 
                                    type="button" 
                                    class="btn btn-kirim" 
                                    @click="handleKirimClick"
                                >
                                    Kirim
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Confirmation Modal -->
        <transition name="modal">
            <div v-if="showConfirmModal" class="confirm-modal-mask">
                <div class="confirm-modal-wrapper" @click="showConfirmModal = false">
                    <div class="confirm-modal-container" @click.stop>
                        <!-- Header -->
                        <div class="confirm-header d-flex justify-content-between align-items-center">
                            <h6 class="confirm-title mb-0">Konfirmasi Pengiriman QR</h6>
                            <button type="button" class="btn btn-close-confirm" @click="showConfirmModal = false">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <!-- Body Content -->
                        <div class="confirm-body text-center">
                            <div class="confirm-icon-wrapper">
                                <svg width="108" height="98" viewBox="0 0 124 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M53.493 2.18918C61.9236 -2.48607 72.6478 0.58571 77.359 8.94096L122.425 87.1547C123.417 89.4893 123.851 91.3877 123.975 93.3597C124.223 97.9674 122.611 102.446 119.45 105.893C116.288 109.327 112.011 111.354 107.362 111.6H16.6092C14.6875 111.483 12.7659 111.047 10.9682 110.371C1.97967 106.747 -2.3596 96.5482 1.29778 87.7077L46.6741 8.88567C48.2239 6.11492 50.5795 3.72507 53.493 2.18918ZM61.9856 76.0902C59.0101 76.0902 56.5305 78.5476 56.5305 81.5027C56.5305 84.4454 59.0101 86.909 61.9856 86.909C64.9611 86.909 67.3786 84.4454 67.3786 81.4351C67.3786 78.4923 64.9611 76.0902 61.9856 76.0902ZM61.9856 37.7604C59.0101 37.7604 56.5305 40.1503 56.5305 43.1054V60.4855C56.5305 63.4344 59.0101 65.898 61.9856 65.898C64.9611 65.898 67.3786 63.4344 67.3786 60.4855V43.1054C67.3786 40.1503 64.9611 37.7604 61.9856 37.7604Z" fill="#F36F21"/>
                                </svg>
                            </div>

                            <div class="confirm-text">
                                <p class="mb-1">Anda akan yakin mengirim <strong>{{ numberWithCommas(qty) }}</strong> QR ke</p>
                                <p class="mb-2 font-weight-bold confirm-dealer-name">{{ getPosLabel(kode_dealer) }}</p>
                                <p class="mb-0 text-muted-sub">Apa anda yakin sudah benar?</p>
                            </div>
                        </div>

                        <!-- Actions -->
                        <div class="confirm-actions d-flex justify-content-center align-items-center">
                            <button 
                                type="button" 
                                class="btn btn-confirm-batal" 
                                @click="showConfirmModal = false"
                            >
                                Batal
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-confirm-submit" 
                                :disabled="isSubmitting"
                                @click="confirmAndSend"
                            >
                                <span v-if="isSubmitting">Mengirim...</span>
                                <span v-else>Ya, Kirim</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { fetchTransferQtyOptions } from '@/services/transfer-qty-options';

export default {
    components: {
        Multiselect
    },
    data() {
        return {
            id: '',
            package_code: '',
            kode_dealer: '',
            qty: null,
            sender_signature: null,
            showConfirmModal: false,
            isSubmitting: false,
            posData: [],
            transferQtyOptions: []
        }
    },
    computed: {
        posCodeOptions() {
            const codes = (this.posData || []).map(x => x.code).filter(Boolean);
            if (this.kode_dealer && !codes.includes(this.kode_dealer)) {
                return [this.kode_dealer, ...codes];
            }
            return codes;
        },
        qtyOptions() {
            const base = this.transferQtyOptions && this.transferQtyOptions.length > 0
                ? this.transferQtyOptions
                : [];
            if (this.qty && !base.includes(Number(this.qty))) {
                return [Number(this.qty), ...base].sort((a, b) => a - b);
            }
            return base;
        }
    },
    mounted() {
        this.loadPosOptions();
        this.loadTransferQtyOptions();
        this.showData();
    },
    methods: {
        async loadTransferQtyOptions() {
            try {
                this.transferQtyOptions = await fetchTransferQtyOptions(this.$http);
            } catch (err) {
                // Fallback to default
            }
        },
        async loadPosOptions() {
            try {
                const response = await this.$http.get('/api/master/pos');
                this.posData = response.data.data || [];
            } catch (err) {
                console.log(err);
            }
        },
        getPosLabel(code) {
            if (!code) return '';
            const pos = (this.posData || []).find(x => x.code === code);
            if (pos) {
                if (pos.name) {
                    return pos.name.includes(pos.code) ? pos.name : `${pos.code} - ${pos.name}`;
                }
                return pos.code;
            }
            return code;
        },
        getQtyLabel(val) {
            if (!val) return '';
            return this.numberWithCommas(val);
        },
        numberWithCommas(x) {
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
        },
        addQtyTag(newTag) {
            const num = parseInt(newTag.toString().replace(/\./g, ''), 10);
            if (!isNaN(num) && num > 0) {
                this.qty = num;
            }
        },
        resetBody() {
            this.package_code = '';
            this.kode_dealer = '';
            this.qty = null;
            this.showConfirmModal = false;
            this.isSubmitting = false;
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.clearSignature();
            }
        },
        showData() {
            if (!this.$parent || !this.$parent.dataEdit) return;
            this.id = this.$parent.dataEdit.id;
            this.package_code = this.$parent.dataEdit.package_code || '';
            this.kode_dealer = this.$parent.dataEdit.kode_dealer || '';
            this.qty = this.$parent.dataEdit.qty || null;
            try {
                if (this.$parent.dataEdit.sender_signature) {
                    const image = new Image();
                    image.src = this.$parent.dataEdit.sender_signature;
                    image.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = image.width;
                        canvas.height = image.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(image, 0, 0);
                        canvas.toBlob(blob => {
                            if (this.$refs.signaturePad) {
                                this.$refs.signaturePad.fromDataURL(URL.createObjectURL(blob));
                            }
                        }, 'image/png', 1);
                    };
                }
            } catch (err) {
                console.log(err);
            }
        },
        handleKirimClick() {
            let errors = [];
            if (!this.kode_dealer) {
                errors.push('Pos Tujuan wajib dipilih');
            }
            if (!this.qty || this.qty <= 0) {
                errors.push('Jumlah QR tidak boleh 0');
            }

            if (this.$refs.signaturePad) {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                if (isEmpty) {
                    errors.push('Tanda tangan wajib diisi');
                } else {
                    this.sender_signature = data.split(",")[1];
                }
            } else if (!this.sender_signature) {
                errors.push('Tanda tangan wajib diisi');
            }

            if (errors.length > 0) {
                this.$swal.fire({
                    title: "Error",
                    html: `<p>> ${errors.join("<br>> ")}</p>`,
                    icon: "error",
                });
                return;
            }

            // Open confirmation modal
            this.showConfirmModal = true;
        },
        async confirmAndSend() {
            try {
                this.isSubmitting = true;
                let datasend = {
                    kode_dealer: this.kode_dealer,
                    qty: Number(this.qty),
                    sender_signature: this.sender_signature
                };

                await this.$http.put('/api/qrs/issue/' + this.id, datasend);

                this.$swal.fire({
                    title: "Success",
                    text: "Pengiriman berhasil diubah",
                    icon: "success",
                });
                this.showConfirmModal = false;
                this.$emit('updateTable');
                this.$emit('closeModal');
                this.resetBody();
            } catch (err) {
                console.log(err);
                this.$swal.fire({
                    title: "Error",
                    text: err.response && err.response.data && err.response.data.message ? err.response.data.message : (err.message || "Gagal mengubah pengiriman"),
                    icon: "error"
                });
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    padding: 20px;
}

.modal-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-container {
    width: 521px;
    max-width: 521px;
    min-height: 357px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    padding: 0;
    overflow: hidden;
    transform: rotate(0deg);
    opacity: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.modal-header-custom {
    height: 48px;
    padding: 12px 20px;
    border-bottom: 1px solid #F3F4F6;
    flex-shrink: 0;
    box-sizing: border-box;
}

.back-btn {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none;
    line-height: 1;
}

.modal-title-custom {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
}

.btn-close-custom {
    padding: 0;
    border: none;
    background: transparent;
    color: #111827;
    font-size: 16px;
    cursor: pointer;
    line-height: 1;
    outline: none;
    box-shadow: none;
}

.btn-close-custom:hover {
    color: #6B7280;
}

.modal-body-custom {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.modal-form-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.modal-form-row.align-top {
    align-items: flex-start;
    margin-bottom: 20px;
}

.modal-form-label {
    width: 112px;
    min-width: 112px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #2F2F2F;
}

.modal-form-input {
    flex: 1;
    min-width: 0;
}

.signature-box {
    border: 1px solid #E5E7EB;
    border-radius: 4px;
    position: relative;
    background: #FFFFFF;
    overflow: hidden;
    height: 118px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.signature-box canvas {
    display: block;
}

.btn-clear-signature {
    position: absolute;
    bottom: 8px;
    right: 12px;
    background: transparent;
    border: none;
    color: #ADADAD;
    font-size: 13px;
    cursor: pointer;
    padding: 0;
    outline: none;
    line-height: 1;
}

.btn-clear-signature:hover {
    color: #6B7280;
}

.modal-actions-row {
    margin-top: 0;
}

.btn-batal {
    background: transparent;
    border: none;
    color: #F36F21;
    font-size: 14px;
    font-weight: 500;
    padding: 0;
    margin-right: 20px;
    box-shadow: none;
    cursor: pointer;
    outline: none;
    line-height: 1;
}

.btn-batal:hover {
    color: #D95D16;
}

.btn-kirim {
    background-color: #F36F21;
    border: 1px solid #F36F21;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    width: 100px;
    height: 31px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    cursor: pointer;
    outline: none;
    line-height: 1;
    transition: background-color 0.2s, border-color 0.2s;
}

.btn-kirim:hover:not(:disabled) {
    background-color: #D95D16;
    border-color: #D95D16;
    color: #FFFFFF;
}

.btn-kirim:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Confirmation Modal Specific Styles */
.confirm-modal-mask {
    position: fixed;
    z-index: 1060;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    padding: 20px;
}

.confirm-modal-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.confirm-modal-container {
    width: 401px;
    max-width: 401px;
    height: 330px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
    padding: 16px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    transform: rotate(0deg);
    opacity: 1;
    box-sizing: border-box;
}

.confirm-header {
    width: 100%;
}

.confirm-title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
}

.btn-close-confirm {
    padding: 0;
    border: none;
    background: transparent;
    color: #111827;
    font-size: 16px;
    cursor: pointer;
    line-height: 1;
}

.btn-close-confirm:hover {
    color: #6B7280;
}

.confirm-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto 0;
}

.confirm-icon-wrapper {
    margin-bottom: 14px;
}

.confirm-icon-wrapper svg {
    display: block;
}

.confirm-text {
    font-size: 13px;
    color: #1F2937;
    line-height: 1.4;
}

.confirm-dealer-name {
    font-size: 13px;
    color: #111827;
    word-break: break-word;
}

.text-muted-sub {
    font-size: 13px;
    color: #374151;
    margin-top: 6px;
}

.confirm-actions {
    margin-top: 8px;
}

.btn-confirm-batal {
    background: transparent;
    border: none;
    color: #F36F21;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 20px;
    margin-right: 16px;
    cursor: pointer;
    box-shadow: none;
}

.btn-confirm-batal:hover {
    color: #D95D16;
    background: transparent;
}

.btn-confirm-submit {
    background-color: #F36F21;
    border: 1px solid #F36F21;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 8px 32px;
    min-width: 130px;
    box-shadow: none;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-confirm-submit:hover:not(:disabled) {
    background-color: #D95D16;
    border-color: #D95D16;
    color: #FFFFFF;
}

.btn-confirm-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container,
.modal-enter .confirm-modal-container,
.modal-leave-active .confirm-modal-container {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
}
</style>

<style>
/* Multiselect overrides inside modal */
.custom-modal-select.multiselect {
    min-height: 30px !important;
    height: 30px !important;
    font-size: 14px;
}

.dealerDashboard .custom-modal-select.multiselect .multiselect__tags,
.custom-modal-select .multiselect__tags {
    min-height: 30px !important;
    height: 30px !important;
    padding: 4px 30px 0 12px !important;
    border: 1px solid #E5E7EB !important;
    border-radius: 4px !important;
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    display: block !important;
    width: 100% !important;
}

.dealerDashboard .custom-modal-select.multiselect .multiselect__single,
.custom-modal-select .multiselect__single {
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    font-family: inherit !important;
    color: #1F2937 !important;
    background-color: transparent !important;
    line-height: 20px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block !important;
}

.dealerDashboard .custom-modal-select.multiselect .multiselect__select,
.custom-modal-select .multiselect__select {
    height: 28px !important;
    width: 30px !important;
    padding: 0 !important;
    top: 1px !important;
    right: 1px !important;
    background-color: transparent !important;
}

.dealerDashboard .custom-modal-select.multiselect .multiselect__select::before,
.custom-modal-select .multiselect__select::before {
    border-color: #6B7280 transparent transparent !important;
    border-width: 5px 4px 0 4px !important;
    top: 55% !important;
    margin: 0 !important;
}

.dealerDashboard .custom-modal-select.multiselect .multiselect__placeholder,
.custom-modal-select .multiselect__placeholder {
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    padding-left: 0 !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    font-family: inherit !important;
    color: #9CA3AF !important;
    background-color: transparent !important;
    line-height: 20px !important;
    display: inline-block !important;
}

.dealerDashboard .custom-modal-select.multiselect .multiselect__input,
.custom-modal-select .multiselect__input {
    font-size: 13px !important;
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    line-height: 20px !important;
    min-height: 20px !important;
    height: 20px !important;
    background-color: transparent !important;
    color: #1F2937 !important;
    display: inline-block !important;
}

.custom-modal-select .multiselect__content-wrapper {
    border: 1px solid #E5E7EB !important;
    border-radius: 4px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    font-size: 13px !important;
    background-color: #FFFFFF !important;
    max-height: 180px;
}

.custom-modal-select .multiselect__option--highlight {
    background: #F36F21 !important;
    color: #FFFFFF !important;
}

.custom-modal-select .multiselect__option--selected.multiselect__option--highlight {
    background: #D95D16 !important;
    color: #FFFFFF !important;
}
</style>